import IconoFacebook from './IconoFacebook'
import IconoInstagram from './IconoInstagram'
import IconoTikTok from './IconoTikTok'

const ICONOS = {
  instagram: IconoInstagram,
  facebook: IconoFacebook,
  tiktok: IconoTikTok,
}

/**
 * Fila de íconos de redes sociales. No renderiza nada si `redes` está vacío
 * (hoy lo está a propósito: ver contenido.js). Cada entrada trae su `id`
 * para mapear al ícono correcto; si llega una red sin ícono propio, cae de
 * vuelta al nombre en texto en vez de romper.
 */
function RedesSociales({ redes, className = '' }) {
  if (redes.length === 0) return null

  return (
    <ul className={`flex flex-wrap gap-3 ${className}`}>
      {redes.map((red) => {
        const Icono = ICONOS[red.id]
        return (
          <li key={red.url}>
            <a
              href={red.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={red.nombre}
              className="area-tactil -m-2 flex items-center justify-center rounded-full border border-oro-profundo/30 p-2 text-marfil-suave transition-colors hover:border-oro-claro hover:text-oro-claro"
            >
              {Icono ? <Icono /> : <span className="text-xs">{red.nombre}</span>}
            </a>
          </li>
        )
      })}
    </ul>
  )
}

export default RedesSociales
